import { app } from '@/vendors/firebase/firebase';
import managerTransformer from './managerTransformer';

export default {
  async getSuppliersByShopId(email) {
    const res = [];
    const snapshot = await app.firestore()
      .collection('managers')
      .where('email', '==', email)
      .get();
    snapshot.forEach((doc) => {
      res.push(managerTransformer.transformOne(doc.data()));
    });
    return managerTransformer.transformList(res);
  },
};
